import { Component, Inject, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { StoreData } from "@bitwarden/web-vault/app/models/store/store.data";
import { NotificationEnum } from "@bitwarden/web-vault/app/models/enum/notification.enum";
import { ConfirmationDialogService } from "@bitwarden/web-vault/app/services/confirmation/confirmation.service";
import { GlossScrollDirective } from "@bitwarden/web-vault/app/components/gloss-scroll/gloss-scroll.directive";

export interface VaultJsonObjectDialogData {
  title: string;
  item: StoreData;
}

@Component({
  selector: "app-vault-json-object-dialog",
  standalone: true,
  imports: [GlossScrollDirective, MatDialogModule, MatButtonModule],
  templateUrl: "./vault-json-object-dialog.component.html",
})
export class VaultJsonObjectDialogComponent {
  private confirmationService = inject(ConfirmationDialogService);

  constructor(@Inject(MAT_DIALOG_DATA) public data: VaultJsonObjectDialogData) {}

  itemJson(): string {
    try {
      return JSON.stringify(this.data.item, null, 2);
    } catch {
      return String(this.data.item);
    }
  }

  copy(): void {
    const text = this.itemJson();
    const clipboard = navigator.clipboard;
    if (!clipboard?.writeText) {
      this.confirmationService.notify(
        NotificationEnum.error,
        "Copy failed",
        "Clipboard is not available in this context.",
        false,
      );
      return;
    }

    void clipboard.writeText(text).then(
      () =>
        this.confirmationService.notify(
          NotificationEnum.success,
          "Copied",
          "JSON copied to clipboard.",
          false,
        ),
      () =>
        this.confirmationService.notify(
          NotificationEnum.error,
          "Copy failed",
          "Could not copy to clipboard.",
          false,
        ),
    );
  }
}
